module.exports = __webpack_public_path__ + "static/black-future-88-red-e7846523e87517362011bbf20fa98e7b.png";